import React, { useRef, useState } from "react";
import ReactDOM from "react-dom";
import JqxGrid from "jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid";
import { useTranslation } from "react-i18next";
import {
  getTheme,
  mergeStyleSets,
  FontWeights,
  Dialog,
  DialogType,
  DialogFooter,
  SpinnerSize,
  TooltipHost,
} from "@fluentui/react";
import { CommandBar } from "@fluentui/react/lib/CommandBar";
import { Col, Form, Row } from "react-bootstrap";
import { useGetDocumentListByBook } from "../../../../hooks/services/sBook/useOfDocument";
import { base64ToArrayBuffer, isNullUndefined, saveByteArray } from "../../../../common/Helpers";
import { OverflowSet } from "@fluentui/react/lib/OverflowSet";
import { PrimaryButton, DefaultButton } from "@fluentui/react/lib/Button";
import Loading from "../../../Templates/Site/Loading";
import { FILE_MAX_SIZE } from "../../../../configurations/application.config";
import {
  bookDocumentaddGetUrl,
  downloadDocumentsByIds,
  getDocumentListByBook,
} from "../../../../services/sBook/document.service";
import Message from "../../../Common/Message";
import { __onRenderOverflowButton, __onRenderOverflowItem } from "../../../../common/CommonFuctions";
import { envBlobDocumentUpload, envDocumentValidate } from "../../../../services/Env/transversal.service";

function DocumentLinkModal(props) {
  const { t } = useTranslation();

  const inputParam_BookObject =
    props.bookObject !== null && props.bookObject !== undefined ? props.bookObject : null;
  const inputParam_IsModalOpen =
    props.isModalOpen !== null && props.isModalOpen !== undefined ? props.isModalOpen : null;
  const inputParam_SetterIsModalOpen =
    props.setIsModalOpen !== null && props.setIsModalOpen !== undefined
      ? props.setIsModalOpen
      : null;
  const inputParam_UserProps = props.userProps !== null && props.userProps !== undefined ? props.userProps : null;


  const inputParam_SetterSelectedDocumentToLink =
    props.setterSelectedDocumentToLink !== null && props.setterSelectedDocumentToLink !== undefined
      ? props.setterSelectedDocumentToLink
      : null;
  const inputParam_EditMode =
    props.editMode !== null && props.editMode !== undefined ? props.editMode : true;
  
  const fileUploadControl = useRef();

  const [successful, setSuccessful] = useState(null);
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(null);
  const [showMessage, setShowMessage] = useState(false);
  const [uploadInProgress, setUploadInProgress] = useState(false);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const [hasSelection, setHasSelection] = useState(false);

  const theme = getTheme();
  const contentStyles = mergeStyleSets({
    container: {
      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "stretch",
    },
    header: [
      {
        flex: "1 1 auto",
        borderTop: `4px solid ${theme.palette.themePrimary}`,
        color: theme.palette.neutralPrimary,
        display: "flex",
        alignItems: "center",
        fontWeight: FontWeights.semibold,
        padding: "12px 12px 14px 24px",
      },
    ],
    body: {
      flex: "4 4 auto",
      padding: "0 24px 24px 24px",
      overflowY: "hidden",
      selectors: {
        p: { margin: "14px 0" },
        "p:first-child": { marginTop: 0 },
        "p:last-child": { marginBottom: 0 },
      },
    },
    footer: [
      {
        flex: "1 1 auto",
        borderTop: `1px solid ${theme.palette.green}`,
        color: theme.palette.neutralPrimary,
        display: "flex",
        fontWeight: FontWeights.semibold,
        padding: "12px 12px 14px 24px",
      },
    ],
  });

  const [documentLinkList, setDocumentLinkList] = useState(null);
  const [documentGetFired, setDocumentGetFired] = useState(null);
  
  useGetDocumentListByBook(
    inputParam_BookObject !== null ? inputParam_BookObject.id : 0,
    documentLinkList,
    setDocumentLinkList,
    documentGetFired, setDocumentGetFired,
    (!isNullUndefined(inputParam_UserProps.partyMemberId)) ? inputParam_UserProps.partyMemberId : 0
  );

  const [selectedFile, setSelectedFile] = useState(null);

  const gridRef = useRef(null);
  const selectedIdsRef = useRef(new Set()); // fuente de la verdad de selección
  const applyingRef = useRef(false); // evita loops al re-aplicar selección

  const applySelection = () => {
    const grid = gridRef.current;
    if (!grid) return;
    applyingRef.current = true;
    grid.clearselection();
    selectedIdsRef.current.forEach((id) => {
      const idx = grid.getrowboundindexbyid(id);
      if (idx >= 0) grid.selectrow(idx);
    });
    applyingRef.current = false;

    const selCount = (grid.getselectedrowindexes() || []).length;
    setHasSelection(selCount > 0);
  };

  const onDownloadDocumentsByIds = (documentList, fileName) => {
    setDownloadInProgress(true);
    downloadDocumentsByIds(documentList)
      .then((response) => {
        saveByteArray(fileName, base64ToArrayBuffer(response.data.data));
        setDownloadInProgress(false);
      })
      .catch(() => {
        setShowMessage(true);
        setSuccessful(false);
        setMessageType("error");
        setMessage(t("data-lang-msg-operationerror"));
        setDownloadInProgress(false);
      });
  };

  const onCancelUpload = () => {
      setSelectedFile(null);
      fileUploadControl.current.value = "";
      setShowMessage(false);
      setSuccessful(false);
      setMessageType("error");
      setMessage('');
  }

  const onUploadFile = async () => {
    if (!isNullUndefined(selectedFile)) {
        if (handleFileInput(selectedFile)) {
            setShowMessage(false);
            setSuccessful(false);
            setMessageType("error");
            setMessage('');
            setUploadInProgress(true);
            await bookDocumentaddGetUrl(inputParam_BookObject.id, selectedFile.name).then(async (responseAdd) => {
                if (responseAdd.data.succeeded === true) {
                  await envBlobDocumentUpload(responseAdd.data.data.url, responseAdd.data.data.fileName, selectedFile).then(async (responseAzure) => {
                    if (responseAzure.data === "" && responseAzure.status === 201) {
                      await envDocumentValidate(responseAdd.data.data.document_id).then(async (responseValidate) => {
                        if (responseValidate.data.succeeded === true) {
                          if (responseValidate.data.data.result_validate === true) {
                            await getDocumentListByBook(inputParam_BookObject.id, inputParam_UserProps.partyMemberId).then(async (serviceResponse) => {
                              const responseGetAll = serviceResponse.data;
                              if (responseGetAll.succeeded) {
                                const grid = gridRef.current;
                                if (!grid) return;

                                const id = responseValidate.data.data.document_id;
                                const itemDocumento = responseGetAll.data.find((x) => x.id === id);

                                setDocumentLinkList((prev) => [itemDocumento, ...(prev || [])]);

                                grid.addrow(itemDocumento.id, itemDocumento, "first");

                                selectedIdsRef.current.add(String(itemDocumento.id));

                                applySelection();

                                const boundIndex = grid.getrowboundindexbyid(itemDocumento.id);
                                if (boundIndex >= 0) grid.ensurerowvisible(boundIndex);

                                setShowMessage(true);
                                setSuccessful(true);
                                setMessageType("success");
                                setMessage(t("data-lang-msg-operationperformed"));
                                if (fileUploadControl.current) {
                                    fileUploadControl.current.value = '';
                                }
                              } else {
                                setShowMessage(true);
                                setSuccessful(false);
                                setMessageType("error");
                                setMessage(t("data-lang-msg-filesizeerror"));
                              }
                            })
                            .catch((error) => {
                              setShowMessage(true);
                              setSuccessful(false);
                              setMessageType("error");
                              setMessage(t("data-lang-msg-operationerror"));
                              setUploadInProgress(false);
                            });
                          }
                          else {
                              setShowMessage(true);
                              setSuccessful(false);
                              setMessageType("error");
                              setMessage(t(responseValidate.data.data.result_validate_msg));
                              setUploadInProgress(false);
                          }
                        }
                        else {
                          setShowMessage(true);
                          setSuccessful(false);
                          setMessageType("error");
                          setMessage(t("data-lang-msg-operationerror"));
                          setUploadInProgress(false);
                        }
                      });
                    }
                    else {
                      setShowMessage(true);
                      setSuccessful(false);
                      setMessageType("error");
                      setMessage(t("data-lang-msg-operationerror"));
                      setUploadInProgress(false);
                    }
                  })
                  .catch((error) => {
                    setShowMessage(true);
                    setSuccessful(false);
                    setMessageType("error");
                    setMessage(t("data-lang-msg-operationerror"));
                    setUploadInProgress(false);
                  });
                } else {
                  setShowMessage(true);
                  setSuccessful(false);
                  setMessageType("error");
                  setMessage(t("data-lang-msg-operationerror"));
                }

                setSelectedFile(null);
                setUploadInProgress(false);
            })
            .catch(() => {
              setShowMessage(true);
              setSuccessful(false);
              setMessageType("error");
              setMessage(t("data-lang-msg-operationerror"));
              setUploadInProgress(false);
            });
        }
        else {
            setShowMessage(true);
            setSuccessful(false);
            setMessageType("warning");
            setMessage(t("data-lang-msg-filesizeerror"));
        }
    }
    else {
        setShowMessage(true);
        setSuccessful(false);
        setMessageType("error");
        setMessage(t("data-lang-msg-selectfile"));
    }
  };

  const onSelectDocuments = () => {
    const grid = gridRef.current;
    if (!grid) return;

    const ids = Array.from(selectedIdsRef.current);
    const documentSelectionToLinkList = [];
    ids.forEach((id) => {
      const idx = grid.getrowboundindexbyid(id);
      if (idx >= 0) {
        const row = grid.getrowdata(idx);
        if (row) {
            row.onTheFlyDocument = true;
            documentSelectionToLinkList.push(row);
        }
      }
    });

    inputParam_SetterSelectedDocumentToLink && inputParam_SetterSelectedDocumentToLink(documentSelectionToLinkList);
    inputParam_SetterIsModalOpen && inputParam_SetterIsModalOpen(false);
  };

  // Usa el value (id) que entrega jqx en la columna 'id'
  const actionCellsRenderer = (itemId) => {
    const grid = gridRef.current;
    const idx = grid?.getrowboundindexbyid(itemId);
    const rowData = idx >= 0 ? grid?.getrowdata(idx) : null;

    return (
      <div>
        {downloadInProgress ? (
          <Loading
            inputParam_ShowLoading={true}
            inputParam_ShowText={false}
            inputParam_Width={"25px"}
            inputParam_Height={"25px"}
            inputParam_Left={""}
            inputParam_Style={{marginTop: 0}}
            inputParam_ColClassName={"me-2"}
            inputParam_MarginLeft={"auto"}
            inputParam_SpinnerSize={SpinnerSize.medium}
          />
        ) : (
          <OverflowSet
            className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
            role="menubar"
            items={[
              {
                key: "download",
                icon: "CloudDownload",
                name: t("data-lang-btn-download"),
                title: t("data-lang-btn-download"),
                onClick: () =>
                  onDownloadDocumentsByIds([itemId], rowData?.name /* puede venir null */),
              },
            ]}
            onRenderOverflowButton={__onRenderOverflowButton}
            onRenderItem={__onRenderOverflowItem}
          />
        )}
      </div>
    );
  };

  const handleFileInput = (e) => {
      // handle validations
      const file = !isNullUndefined(e.target) ? e.target.files[0] : e;
      let flag = false;
      
      if (file) {
          const maxSizeInMB = FILE_MAX_SIZE;
          const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

          if (file.size > maxSizeInBytes) {
              setShowMessage(true);
              setSuccessful(false);
              setMessageType("warning");
              setMessage(t("data-lang-msg-filesizeerror"));
              setSelectedFile(file);
          }
          else {
              flag = true;
              setSelectedFile(file);
          }
      }

      return flag;
  };

  const onColseModal = () => {
    inputParam_SetterIsModalOpen && inputParam_SetterIsModalOpen(false);
  };

  const onRowselect = (e) => {
    const grid = gridRef.current;
    if (!grid) return;
    if (applyingRef.current) return; // ignorar cuando aplicamos nosotros

    const id = e?.args?.row?.id;
    if (id != null) selectedIdsRef.current.add(String(id));
    setHasSelection((grid.getselectedrowindexes() || []).length > 0);
  };

  const onRowunselect = (e) => {
    const grid = gridRef.current;
    if (!grid) return;
    if (applyingRef.current) return; // ignorar cuando aplicamos nosotros

    const id = e?.args?.row?.id;
    if (id != null) selectedIdsRef.current.delete(String(id));
    setHasSelection((grid.getselectedrowindexes() || []).length > 0);
  };

  const onBindingcomplete = () => {
    // si el grid se re-bindea (p.ej. por cambios en source), re-aplica lo seleccionado
    applySelection();
  };

  // Render
  return (
    <Dialog
      hidden={!inputParam_IsModalOpen}
      onDismiss={onColseModal}
      minWidth={850}
      maxWidth={1300}
      dialogContentProps={{
        type: DialogType.normal,
        styles: {
          header: {
            borderBottom: "2px solid #e8e8e8",
          },
        },
        title: t("data-lang-boxname-bookdocuments"),
      }}
      modalProps={{
        isBlocking: true,

        // Permite que jqxGrid reciba mousemove/mouseup
        // al arrastrar su scrollbar personalizado.
        layerProps: {
          eventBubblingEnabled: true,
        },
      }}
    >
      {
        documentGetFired === false &&
        <>
          <div>
            <Message
              message={
                hasSelection
                  ? t("data-lang-msg-bookdocumentsselected")
                  : t("data-lang-msg-bookdocumentsnoselection")
              }
              display={true}
              messageType={hasSelection ? "info" : "warning"}
              setterShowMessage={null}
            />
          </div>

          {inputParam_EditMode === true && (
            <div className="d-flex">
              <div className="d-flex align-items-center">
                {!uploadInProgress &&
                  <CommandBar
                    items={[
                      {
                        key: "uploadDocument",
                        text: t("data-lang-btn-uploaddocument"),
                        iconProps: { iconName: "Upload" },
                        onClick: () => onUploadFile(),
                        disabled: selectedFile === null,
                      },
                      {
                          key: 'cancelUploadDocument',
                          text: t('data-lang-btn-cancel'),
                          iconProps: { iconName: 'RemoveFilter' },
                          onClick: () => onCancelUpload(),
                          disabled: selectedFile === null
                      }
                    ]}
                  />
                }
                {uploadInProgress && (
                  <Loading
                    inputParam_ShowLoading={true}
                    inputParam_ShowText={false}
                    inputParam_Width={"35px"}
                    inputParam_Height={"35px"}
                    inputParam_Left={""}
                    inputParam_Style={{marginTop: 0}}
                    inputParam_ColClassName={"me-2"}
                    inputParam_MarginLeft={"auto"}
                    inputParam_SpinnerSize={SpinnerSize.medium}
                  />
                )}
                <TooltipHost content={
                  <>
                    <div>{'Tool TIP Archivos Permitidos: "7z", "doc", "docx", "eml", "jpeg", "jpg", "msg", "ods", "pdf", "png", "ppt", "pptx", "rar", "txt", "xls", "xlsb", "xlsx", "xps", "zip“. Peso: 80mb.'}</div>
                    <div>{'Si tiene problemas con estos formatos, sugerimos guardar nuevamente el archivo con un programa estándar, ejemplo: Archivo de imagen “.jpg”  o “.png” utilizar abrir en “Paint” y volver a guardar.'}</div>
                  </>
                }>
                  <Form.Control ref={fileUploadControl} type="file" size="sm" onChange={handleFileInput} />
                </TooltipHost>
              </div>
            </div>
          )}

          {!isNullUndefined(documentLinkList) && (
            <div className={"document-selection-zone " + contentStyles.body}>
              <div style={{ height: "100%", position: "relative" }}>
                <JqxGrid
                  ref={gridRef}
                  width={"100%"}
                  columns={[
                    { text: t("data-lang-lbl-code"), datafield: "documentCode", width: "20%" },
                    { text: t("data-lang-lbl-name"), datafield: "name", width: "40%" },
                    {
                      text: t("data-lang-lbl-creationusername"),
                      datafield: "creationUsername",
                      width: "25%",
                    },
                    {
                      text: t("data-lang-lbl-actions"),
                      datafield: "id", // <- minúsculas
                      width: "10%",
                      createwidget: (row, column, value, htmlElement) => {
                        ReactDOM.render(actionCellsRenderer(value), htmlElement); // value === id
                      },
                      initwidget: (row, column, value, htmlElement) => {
                        ReactDOM.render(actionCellsRenderer(value), htmlElement); // value === id
                      },
                    },
                  ]}
                  selectionmode={"checkbox"}
                  pageable={false}
                  autoheight={false}
                  height={"480px"}
                  altrows={true}
                  columnsresize={true}
                  source={
                    new window.jqx.dataAdapter({
                      localdata: documentLinkList || [], // <- minúsculas
                      datatype: "array",
                      id: "id",
                      datafields: [
                        { name: "id", type: "number" },
                        { name: "documentCode", type: "string" },
                        { name: "name", type: "string" },
                        { name: "creationUsername", type: "string" },
                      ],
                    })
                  }
                  onRowselect={onRowselect}
                  onRowunselect={onRowunselect}
                  onBindingcomplete={onBindingcomplete}
                />
              </div>
            </div>
          )}
        </>
      }
      {
        (isNullUndefined(documentGetFired) || documentGetFired === true)  &&
          <Row className="h-100">
              <Col className="d-flex align-items-center justify-content-center pt-5">
                  <Loading
                      inputParam_ShowLoading={true}
                      inputParam_ShowText={false}
                      inputParam_Width={'35px'}
                      inputParam_Height={'35px'}
                      inputParam_Left={""}
                      inputParam_Style={{marginTop: 0}}
                      inputParam_ColClassName={"me-2"}
                      inputParam_MarginLeft={"auto"}
                      inputParam_SpinnerSize={SpinnerSize.medium} />
              </Col>
          </Row>
      }
      <DialogFooter>
        <div>
            <Message
              message={message}
              display={successful === null ? false : showMessage}
              messageType={messageType}
              setterShowMessage={setShowMessage}
            />
        </div>
      </DialogFooter>
      {
        documentGetFired === false &&
        <DialogFooter className="d-flex">
          <PrimaryButton className="mx-1" disabled={!hasSelection} onClick={hasSelection ? onSelectDocuments : undefined}>{ t("data-lang-btn-accept")}</PrimaryButton>
          <DefaultButton onClick={onColseModal}>{t("data-lang-btn-close")}</DefaultButton>
        </DialogFooter>
      }
    </Dialog>
  );
}

export default DocumentLinkModal;